type Inputs = {
  description: string;
  date: Date;
  ndis_name: string;
  persons: string;
  name: string;
  relationship: string;
  contact: string;
  contact_method: string;
};

const ComplaintsTemplate = ({
  description,
  date,
  ndis_name,
  persons,
  name,
  relationship,
  contact,
  contact_method,
}: Inputs) => {
  const dateValue = new Date(date);
  let dateStr;
  if (isNaN(dateValue.getTime())) {
    dateStr = "";
  } else {
    dateStr = dateValue.toDateString();
  }

  let relationshipValue;
  if (relationship == "Please choose an option") {
    relationshipValue = "";
  } else {
    relationshipValue = relationship;
  }

  return (
    <div style={{ margin: "0 50px" }}>
      <h1
        style={{
          color: "rgb(17, 82, 190)",
          fontSize: "24px",
          lineHeight: 1.2,
          textAlign: "center",
          margin: "24px 0",
        }}
      >
        New Complaint Submission
      </h1>
      <strong>Description: </strong>
      <br />
      {description}
      <br />
      <br />
      <strong>Date of incident: </strong> {dateStr}
      <br />
      <br />
      <strong>NDIS number of participant/s involved:</strong> {ndis_name}
      <br />
      <br />
      <strong>Others involved: </strong> {persons}
      <br />
      <br />
      <hr />
      <br />
      <strong>Name of person lodging complaint: </strong> {name}
      <br />
      <br />
      <strong>Relationship to Provido: </strong> {relationshipValue}
      <br />
      <br />
      <strong>Does this person wish to be contacted?</strong> {contact}
      <br />
      <br />
      <strong>If Yes, contact via: </strong> {contact_method}
      <br />
      <br />
      <div style={{ fontSize: "12px", color: "#808080" }}>
        Please Note: Do not reply to this email. To contact someone regarding
        this complaint via email, you will need to create a new email.
      </div>
    </div>
  );
};

export default ComplaintsTemplate;
